import React from 'react';
import PropTypes from 'prop-types';

class CheckBoxCol extends React.PureComponent {

    render() {
        const { production_status, orderNumber, isChecked, handleChange } = this.props

        return (
            <div className="notDisableCancel bulkActions ml-1">
                {
                    // (production_status !== 'labelled' && production_status !== 'packaged' && production_status !== 'cancelled' && production_status !== 'cancel-ship') && 
                    (
                        <input type='checkbox' className='inputCheckboxSelected'
                            id={`OrderColSelection_${orderNumber}`}
                            onChange={handleChange}
                            checked={isChecked}
                            style={{cursor:'pointer'}}
                        />
                    )}
            </div>
        );
    }
}

CheckBoxCol.propTypes = {
    production_status: PropTypes.string,
    orderNumber: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    isChecked: PropTypes.bool.isRequired
}

export default CheckBoxCol;
